export default class EventEmitter {
  constructor() {
    this.listeners = {};

    this.on = this.addEventListener;
    this.removeListener = this.removeEventListener;
    this.emit = this.dispatchEvent;
  }

  addEventListener(type, callback) {
    if (!this.listeners[type]) {
      this.listeners[type] = [];
    }
    this.listeners[type].push(callback);
  }

  removeEventListener(type, callback) {
    if (this.listeners[type]) {
      for (let i = this.listeners[type].length - 1; i >= 0; i -= 1) {
        if (this.listeners[type][i] === callback) {
          this.listeners[type].splice(i, 1);
        }
      }
    }
  }

  dispatchEvent(type, ...args) {
    if (this.listeners[type]) {
      for (let i = 0; i < this.listeners[type].length; i += 1) {
        if (this.listeners[type][i]) {
          this.listeners[type][i](...args);
        }
      }
    }
  }
}
